export default __webpack_public_path__ + "static/media/twitter.b1e8cb04.svg";